class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    // Listen for estimates updates
    window.addEventListener(
      "estimatesUpdated",
      this.handleEstimatesUpdate.bind(this),
    );

    // Initial load: retrieve estimates from localStorage
    this.estimates = JSON.parse(localStorage.getItem("productEstimates")) || {};
  }

  handleEstimatesUpdate(event) {
    this.estimates = event.detail;
    localStorage.setItem("productEstimates", JSON.stringify(this.estimates));
    // this.sortProductsByProfitability();
  }

  sortProductsByProfitability() {
    const productGrid = document.getElementById("product-grid");
    const products = Array.from(productGrid.querySelectorAll(".grid__item"));

    products.forEach((product) => {
      const id = product.dataset.productId;
      const profitability = Number(this.estimates[id]?.profitability) || 0;
    });

    products.sort((a, b) => {
      const idA = a.dataset.productId;
      const idB = b.dataset.productId;
      const profitA = Number(this.estimates[idA]?.profitability) || 0;
      const profitB = Number(this.estimates[idB]?.profitability) || 0;
      return profitA - profitB; // Ascending order
    });

    // Re-append sorted products
    products.forEach((product) => productGrid.appendChild(product));
  }

  sortProductsBySentiment() {
    // Get the grid container and list container elements.
    const gridContainer = document.getElementById("product-grid");
    const listContainer = document.querySelector(".collection-list-view tbody");
  
    // Helper function to check if an element is visible.
    function isVisible(el) {
      return el && (el.offsetWidth > 0 || el.offsetHeight > 0);
    }
  
    let container, items;

    if (gridContainer && isVisible(gridContainer)) {
      container = gridContainer;
      // For grid view, each product is assumed to be an <li> with class "grid__item"
      items = Array.from(container.querySelectorAll(".grid__item"));
    } else if (listContainer && isVisible(listContainer)) {
      container = listContainer;
      // For list view, assume each product is a <tr> with a data-product-id attribute
      items = Array.from(container.querySelectorAll("tr[data-product-id]"));
    } else {
      return; // No visible container found, exit
    }
  
    // Sort items by descending sentiment.
    items.sort((a, b) => {
      const hdA = a.dataset.hdCollection ? a.dataset.hdCollection.toLowerCase() : "";
      const hdB = b.dataset.hdCollection ? b.dataset.hdCollection.toLowerCase() : "";
      const sentimentA = Number(
        this.estimates.find(x => x.hdCollectionName === hdA)?.sentiment
      ) || 0;
      const sentimentB = Number(
        this.estimates.find(x => x.hdCollectionName === hdB)?.sentiment
      ) || 0;
      return sentimentB - sentimentA;
    });
  
    // Clear the container and re-append sorted items.
    container.innerHTML = "";
    items.forEach((item, index) => {
      container.appendChild(item);
      // If we're in grid view, update the animation order property.
      item.style.setProperty('--animation-order', index + 1);
    });
  }

  sortProductsByEarliestShipping() {
    // Get the grid container and list container elements.
    const gridContainer = document.getElementById("product-grid");
    const listContainer = document.querySelector(".collection-list-view tbody");
  
    // Helper function to determine if an element is visible.
    function isVisible(el) {
      return el && (el.offsetWidth > 0 || el.offsetHeight > 0);
    }
  
    let container, items;
    if (gridContainer && isVisible(gridContainer)) {
      container = gridContainer;
      // For grid view, items are assumed to be <li> elements with the class "grid__item".
      items = Array.from(container.querySelectorAll(".grid__item"));
    } else if (listContainer && isVisible(listContainer)) {
      container = listContainer;
      // For list view, items are assumed to be <tr> elements with a data-product-id attribute.
      items = Array.from(container.querySelectorAll("tr[data-product-id]"));
    } else {
      return; // No visible container found.
    }
  
    // Sort items by the earliest shipping date (ascending).
    // We assume each product element has a data attribute 'data-earliest-shipping'
    // containing an ISO date string (or empty if not available).
    items.sort((a, b) => {
      const dateA = a.dataset.earliestShipping ? new Date(a.dataset.earliestShipping) : new Date(8640000000000000); // Use a very large date if missing
      const dateB = b.dataset.earliestShipping ? new Date(b.dataset.earliestShipping) : new Date(8640000000000000);
      return dateA - dateB;
    });
  
    // Clear the container and re-append the sorted items.
    container.innerHTML = "";
    items.forEach((item) => {
      container.appendChild(item);
    });
  }
  
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function") {
          initializeScrollAnimationTrigger(html.innerHTML);
        }
      });
  }
  
  static renderSectionFromCache(filterDataUrl, event) {
    const cachedData = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!cachedData) return;
    const html = cachedData.html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function") {
      initializeScrollAnimationTrigger(html.innerHTML);
    }
  }
  
  static renderProductContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const gridContainer = document.getElementById("ProductGridContainer");
    const listContainer = document.querySelector(".collection-list-view");
    
    // Check if the list view container exists and is visible (not display:none)
    if (listContainer && window.getComputedStyle(listContainer).display !== "none") {
      const newContent = parsedHTML.querySelector(".collection-list-view")?.innerHTML;
      if (newContent) {
        listContainer.innerHTML = newContent;
      }
    } else if (gridContainer) {
      const newContent = parsedHTML.querySelector("#ProductGridContainer")?.innerHTML;
      if (newContent) {
        gridContainer.innerHTML = newContent;
        gridContainer.querySelectorAll(".scroll-trigger").forEach((element) => {
          element.classList.add("scroll-trigger--cancel");
        });
      }
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter"),
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID),
        );

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains("mobile-facets__details")
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden"),
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item"),
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = event.target.closest("form");

    console.log("onSubmitHandler", form);
    
    if (form) {
      const sortSelect = form.querySelector('select[name="sort_by"]');
      const sortByValue = sortSelect ? sortSelect.value : null;
      console.log("sortByValue", sortByValue);
  
      if (sortByValue === 'community_sentiment') {
        // Call the custom sort function for community sentiment
        this.sortProductsBySentiment();
        window.dispatchEvent(new CustomEvent('estimatesUpdated', { detail: this.estimates }));
        return;
      }
  
      if (sortByValue === 'earliest_shipping') {
        // Call the custom sort function for earliest shipping
        this.sortProductsByEarliestShipping();
        // (Optionally) Fire an event if needed
        window.dispatchEvent(new CustomEvent('estimatesUpdated', { detail: this.estimates }));
        return;
      }
    }
  

    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
    window.dispatchEvent(new CustomEvent('estimatesUpdated', { detail: this.estimates }));
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
